module.exports = __webpack_public_path__ + "static/media/Map6.2d60d5e8.jpg";